import { render, staticRenderFns } from "./DentalWorkspace.vue?vue&type=template&id=2e1a371c&scoped=true"
import script from "./DentalWorkspace.vue?vue&type=script&lang=js"
export * from "./DentalWorkspace.vue?vue&type=script&lang=js"
import style0 from "./DentalWorkspace.vue?vue&type=style&index=0&id=2e1a371c&prod&scoped=true&lang=css"
import style1 from "./DentalWorkspace.vue?vue&type=style&index=1&id=2e1a371c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a371c",
  null
  
)

export default component.exports